import {
    FavoritePerson,
    FavoriteEntity,
    FavoritePrivateDistributionList,
    PersonType,
    HubPersona,
    FavoriteUnifiedGroup,
} from '../../models';

/**
 * Returns whether the passed personaId or mailAddress are part of the favorites.
 * We search for the personaId, and whether the mainEmailAddress appears in the current favorites. If a match is found, we return true.
 */
export function isInFavorites(persona: HubPersona, favorites: FavoriteEntity[]): boolean {
    if (
        persona.type === PersonType.FavoritePerson ||
        persona.type === PersonType.FavoritePrivateDistributionList ||
        persona.type === PersonType.FavoriteUnifiedGroup
    ) {
        return true;
    }

    const matchingFavorite = getMatchingFavorite(persona, favorites);
    return !!matchingFavorite;
}

export function getMatchingFavorite(
    persona: HubPersona,
    favorites: FavoriteEntity[]
): FavoriteEntity {
    switch (persona.type) {
        case PersonType.Person:
        case PersonType.Generic:
            return getMatchingFavoritePerson(
                persona.personaId,
                persona.info.mainEmailAddress,
                favorites
            );

        case PersonType.PrivateDistributionList:
            return getMatchingFavoritePdl(persona.itemId, favorites);
        case PersonType.GroupBasicData:
        case PersonType.Group:
            return getMatchingFavoriteUnifiedGroup(persona.hubPersonaId, favorites);
        default:
            return undefined;
    }
}

export function getMatchingFavoritePerson(
    personaId: string,
    mainEmailAddress: string,
    favorites: FavoriteEntity[]
): FavoritePerson {
    const matchingFavorite = favorites.find(
        currentFavorite =>
            currentFavorite.type === PersonType.FavoritePerson &&
            ((currentFavorite.personaId && personaId && currentFavorite.personaId === personaId) ||
                (currentFavorite.info.mainEmailAddress &&
                    mainEmailAddress &&
                    currentFavorite.info.mainEmailAddress === mainEmailAddress))
    );

    return matchingFavorite as FavoritePerson;
}

function getMatchingFavoritePdl(
    itemId: string,
    favorites: FavoriteEntity[]
): FavoritePrivateDistributionList {
    const matchingFavorite = favorites.find(
        currentFavorite =>
            currentFavorite.type === PersonType.FavoritePrivateDistributionList &&
            currentFavorite.info.itemId === itemId
    );

    return matchingFavorite as FavoritePrivateDistributionList;
}

export function getMatchingFavoriteUnifiedGroup(
    hubPersonaId: string,
    favorites: FavoriteEntity[]
): FavoriteUnifiedGroup {
    const matchingFavorite = favorites.find(
        currentFavorite =>
            currentFavorite.type === PersonType.FavoriteUnifiedGroup &&
            currentFavorite.hubPersonaId &&
            currentFavorite.hubPersonaId === hubPersonaId
    );
    return matchingFavorite as FavoriteUnifiedGroup;
}
